import { createAction } from 'redux-actions'

const ns = 'register-user/'

export const registerUser = createAction(`${ns}REGISTER_USER`)
export const registerUserSuccess = createAction(`${ns}REGISTER_USER_SUCCESS`)
export const registerUserFail = createAction(`${ns}REGISTER_USER_FAIL`)

export const registerAppleHealth = createAction(`${ns}REGISTER_APPLE_HEALTH`)
export const registerAppleHealthSuccess = createAction(`${ns}REGISTER_APPLE_HEALTH_SUCCESS`)
export const registerAppleHealthFail = createAction(`${ns}REGISTER_APPLE_HEALTH_FAIL`)

export const registerHealthConnect = createAction(`${ns}REGISTER_HEALTH_CONNECT`)
export const registerHealthConnectSuccess = createAction(`${ns}REGISTER_HEALTH_CONNECT_SUCCESS`)
export const registerHealthConnectFail = createAction(`${ns}REGISTER_HEALTH_CONNECT_FAIL`)

export const registerWithoutIntegration = createAction(`${ns}REGISTER_WITHOUT_INTEGRATION`)
export const registerWithoutIntegrationSuccess = createAction(`${ns}REGISTER_WITHOUT_INTEGRATION_SUCCESS`)
export const registerWithoutIntegrationFail = createAction(`${ns}REGISTER_WITHOUT_INTEGRATION_FAIL`)

export const setOnboardingStatusToActivityData = createAction(`${ns}SET_ONBOARDING_STATUS_TO_ACTIVITY_DATA`)
export const setOnboardingStatusToIntegration = createAction(`${ns}SET_ONBOARDING_STATUS_TO_INTEGRATION`)

export const updateProfileData = createAction(`${ns}UPDATE_PROFILE_DATA`)

export const updateActivityData = createAction(`${ns}UPDATE_ACTIVITY_DATA`)
export const updateActivityDataSuccess = createAction(`${ns}UPDATE_ACTIVITY_DATA_SUCCESS`)
export const updateActivityDataFail = createAction(`${ns}UPDATE_ACTIVITY_DATA_FAIL`)
